import React from "react";

const SignupPage = () => {
  return (
    <div>
      <h1>Sign Up</h1>
    </div>
  );
};

export default SignupPage;
